export default __webpack_public_path__ + "static/media/opencv.36d7c202.svg";